import * as signalR from '@microsoft/signalr'
const mode = process.env.NODE_ENV
let logLevel
if (mode === "development") {
    logLevel = signalR.LogLevel.Trace
} else {
    logLevel = signalR.LogLevel.Error
}
let signalRConnection = null;
export const buildConnection = (userId) => {
    if (signalRConnection == null) {
        signalRConnection = new signalR.HubConnectionBuilder()
            .withUrl(process.env.REACT_APP_SIGNALR_HUB + "?UserId=" + userId, {
                logMessageContent: true,
                useDefaultCredentials: true
            })
            .configureLogging(logLevel)
            .build();
    }
    return signalRConnection;
}

